<template>
    <GenericMultiStepModal :header-icon="IconSource.Food" :modal-class="currentStep.width" :is-final-step="isFinalStep" @closing="onModalClose">
        <template #default="scope">
            <slot v-bind="scope" />
        </template>
        <template #component="scope">
            <component
                :is="currentStep.component"
                v-model:value="form"
                :reconciliation-id="reconciliation.id"
                :reconciliation="currentStep.component === ReconciliationNextStepPlaceholder ? reconciliation : undefined"
                :text="isFinalStep ? $t('views.feed.reconciliations.newModal.updateSuccessMessage') : undefined"
                @submit="next"
                @close="scope.close"
                @deleted="scope.close"
            ></component>
        </template>
    </GenericMultiStepModal>
</template>

<script lang="ts">
import { defineComponent, Ref, watch } from 'vue';
import { Form } from '@makeabledk/vue-ui/support/http';
import GenericMultiStepModal from '@/components/common/GenericMultiStepModal.vue';
import GenericSubmissionStatus from '@/components/common/GenericSubmissionStatus.vue';
import ReconciliationNextStepPlaceholder from '@/views/dashboard/feed/feedReconciliations/newReconciliationModal/ReconciliationNextStepPlaceholder.vue';
import useMultiSteps from '@/components/common/composables/useMultiSteps';
import useResettableForm from '@/components/common/composables/useResettableForm';
import { FeedReconciliation, IconSource } from '@/types';

export default defineComponent({
    components: { GenericMultiStepModal, GenericSubmissionStatus, ReconciliationNextStepPlaceholder },
    props: {
        reconciliation: {
            type: Object as () => FeedReconciliation,
            required: true,
        },
    },
    setup(props) {
        const multiSteps = useMultiSteps([
            {
                component: ReconciliationNextStepPlaceholder,
                width: 'w-228',
            },
            {
                component: GenericSubmissionStatus,
                width: 'w-128',
            },
        ]);

        function makeFormInitial(r: FeedReconciliation) {
            return {
                location: {
                    locationId: r.location.id,
                    name: r.location.name,
                },
                fromStatusDate: r.from_status_date,
                toStatusDate: r.to_status_date,
            };
        }

        const resettableForm = useResettableForm().setInitial(makeFormInitial(props.reconciliation));
        const form = resettableForm.getInstance() as Ref<Form<any> & any>;

        watch(
            () => props.reconciliation,
            (newValue) => {
                if (newValue) {
                    resettableForm.setInitial(makeFormInitial(newValue));
                }
            }
        );

        function onModalClose() {
            multiSteps.reset();
            resettableForm.reset();
            return true;
        }

        return {
            onModalClose,
            ...multiSteps,
            form,
            IconSource,
            ReconciliationNextStepPlaceholder,
        };
    },
});
</script>
